// Bendra funkcija visoms registracijoms
function submitForm(form) {
    var form_action = form.data('form-action');
    form.find('button').prop('disabled', true);

    grecaptcha.ready(function () {
        grecaptcha.execute('6LdGTLgqAAAAAN6FRk1FGwMy0LDEZ-d_VjOB1trB', {action: form_action}).then(function (token) {
            var data = form.serializeArray();
            data.push({name: 'g-recaptcha-response', value: token});

            $.ajax({
                method: "POST",
                url: form.attr('action'),
                data: data
            }).done(function (data) {
                form.find('.c-form-row, .c-payment-methods-container').removeClass('error hide-error-msg');
                form.find('.c-message--error').removeClass('has-error');

                if (data.status == 0) {
                    form.find('button').prop('disabled', false);

                    $.each(data.errors, function (index, value) {
                        form.find('[name="'+value+'"], [name*="'+value+'["]').closest('.c-form-row, .c-payment-methods-container').addClass('error');
                        if(value == 'age_group') form.find('.c-message--error').addClass('has-error');
                    });

                    $('html, body').animate({
                        scrollTop: ($('#register-form').offset().top - $('.c-site-header').outerHeight()) + 'px'
                    }, 1000, 'swing');
                } else {
                    if(typeof data.url !== "undefined") window.location = data.url;
                }
            });
        });
    });
}

// Bendras eventas visoms registracijoms
$('form.c-form-register.js-ajax').submit(function (e) {
    e.preventDefault();
    submitForm($(this));
});


$(document).on('click','.btn-validate--code', function(e){

    const $field = $(document).find('#discount-code');
    const $top = $(document).find('.c-form--codes');
    const $disc = $(document).find('.discounted-price');
    const $act = $(document).find('#discount_code');

    if($field.val() === ''){
        $field
            .parent()
            .addClass('has-error');
    }else{
        $.ajax({
            method: "POST",
            url: 'registration/check_code',
            data: $('.c-form-register').serialize()
        }).done(function (data) {
            console.log(data);
            data = JSON.parse(data);
            if(data.status == 1){
                $field
                    .parent()
                    .removeClass('has-error');
                $('#discount-code')
                    .attr('disabled', true);
                $('.c-form--validate')
                    .addClass('correct');
                $top.addClass('success');
                $disc.addClass('success');
                $disc.find('.discount-newprice').html( data.new+' €');
                $act.val($('#discount-code').val());
            }
            if(data.status == 0) {
                $field
                    .parent()
                    .addClass('has-error');
            }
        });
    }
})

$(document).on('click','.btn-validate--reset', function(e) {
    const $field = $(document).find('#discount-code');
    const $top = $(document).find('.c-form--codes');
    const $disc = $(document).find('.discounted-price');
    const $act = $(document).find('#discount_code');

    $top.removeClass('success');
    $field.attr('disabled', false);
    $(document)
        .find('.c-form--validate')
        .removeClass('correct');
    $disc.removeClass('success');
    $field.val('');
    $act.val('');

})

// Skirta apmokejimo formai (F2, F3, F4)
$('form.c-form-register.js-non-ajax').submit(function (e) {
    e.preventDefault();
    var $this = $(this);
    var form_action = $this.data('form-action');

    grecaptcha.ready(function () {
        grecaptcha.execute('6LdGTLgqAAAAAN6FRk1FGwMy0LDEZ-d_VjOB1trB', {action: form_action}).then(function (token) {
            $this.prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
            $this.unbind('submit').submit();
            $this.find('button').prop('disabled', true);
        });
    });
});


// Skirta F2 formai, kad is karto suvedus metus rodytu apie amziaus grupes neatitikima
$(document).on('change', '.age-group [name="birthday_y"]', function () {
    var slected_year = parseInt($(this).val());

    if(slected_year < age_group_from || slected_year > age_group_to){
        $('form.c-form-register .c-message--error').addClass('has-error');
        $('form.c-form-register .age-group').addClass('error hide-error-msg');
    }else{
        $('form.c-form-register .c-message--error').removeClass('has-error');
        $('form.c-form-register .age-group').removeClass('error hide-error-msg');
    }
});

// Skirta F3, F4 formai. Iskviesti ugdymo programos turini ir likusia susijusia formos dali
$(document).on('change', '.js-program-change input, .js-birthday-change select', function () {
    var form = $('form.c-form-register.js-ajax');
    var formAction = form.data('form-action');

    $.ajax({
        method: "POST",
        url: 'registration/'+ formAction +'_program',
        data: form.serialize()
    }).done(function (data) {
        if(data.status == 1){
            $('#js-'+ formAction +'-program').html(data.html);

            var fancybox_touch = $(window).width() <= 992 ? true : false;

            $('.call-modal').fancybox({
                type: 'ajax',
                buttons: [
                    "close"
                ],
                touch: fancybox_touch
            });
        }
    });
});

// Bendras eventas skirtas inputo pasirinkimui, rodyti/neordyti susijusi kita inputa
$(document).on('change', '.js-input-relation input', function () {
    var $this = $(this);
    var parentContainer = $this.closest('.js-input-relation');
    var parentTarget = parentContainer.data('parent-target');
    var childTarget = $('[data-child-target="'+ parentTarget +'"]');
    var expectedValue = parentContainer.data('expected-value');

    if($this.attr('type') == 'checkbox'){
        if($this.is(':checked')){
            childTarget.removeClass('hidden');
        }else{
            childTarget.addClass('hidden');
        }
    }else{
        if($this.val() == expectedValue){
            childTarget.removeClass('hidden');
        }else{
            childTarget.addClass('hidden');
        }
    }
});

/* Programu korteliu eventai START */
// Einam i programos korteles 2 zingsni
$(document).on('click', '.js-to-card-2', function (e) {
    var $this = $(this);
    var plan = $this.closest('.c-plan');
    var otherPlans = $('.c-plan').not(plan);

    // uzdarom kitas korteles ir resetinam pasirinkimus
    otherPlans.removeClass('h-card-step-2 h-card-step-3');
    otherPlans.find('input').prop('checked', false);
    otherPlans.find('.js-to-card-finish, .js-to-card-3').addClass('disabled').prop('disabled', true);

    plan.addClass('h-card-step-2');
    plan.find('.programme_id').prop('checked', true);

    e.preventDefault();
});

// 2 koreleje uztikrinam kad bus pasirinkta ir tik tuomet rodome mygtuka testi
$(document).on('click', '.c-plan.h-card-step-2 .c-custom-radio-group input', function () {
    var $this = $(this);
    var plan = $this.closest('.c-plan');
    var planWithFitness = plan.hasClass('has-no-general-fitness');
    var nextBtn = plan.find(planWithFitness ? '.js-to-card-finish' : '.js-to-card-3');
    var listInputsLength = plan.find('.c-custom-radio-group input:checked').length;

    if(listInputsLength !== 0){
        nextBtn.removeClass('disabled').prop('disabled', false);
    }else{
        nextBtn.addClass('disabled').prop('disabled', true);
    }
});

// Einam atgal i programos korteles 1 zingsni
$(document).on('click', '.c-plan.h-card-step-2 .c-btn--back', function (e) {
    var $this = $(this);
    var plan = $this.closest('.c-plan');
    var planWithFitness = plan.hasClass('has-no-general-fitness');

    plan.removeClass('h-card-step-2 h-card-step-3');
    e.preventDefault();
});

// Einam i programos korteles 3 zingsni
$(document).on('click', '.js-to-card-3', function (e) {
    var $this = $(this);
    var plan = $this.closest('.c-plan');

    plan.removeClass('h-card-step-2').addClass('h-card-step-3');

    e.preventDefault();
});

// 3 koreleje uztikrinam kad bus pasirinkta ir tik tuomet rodome mygtuka testi
$(document).on('click', '.c-plan.h-card-step-3 .c-custom-radio-group input', function () {
    var $this = $(this);
    var plan = $this.closest('.c-plan');
    var nextBtn = plan.find('.js-to-card-finish');
    var inputChecked = plan.find('.c-custom-radio-group input:checked');
    var listInputsLength = inputChecked.length;

    if(listInputsLength !== 0){
        nextBtn.removeClass('disabled').prop('disabled', false);
    }else{
        nextBtn.addClass('disabled').prop('disabled', true);
    }
});

// Einam atgal i programos korteles 2 zingsni
$(document).on('click', '.c-plan.h-card-step-3 .c-btn--back', function (e) {
    var $this = $(this);
    var plan = $this.closest('.c-plan');

    plan.removeClass('h-card-step-2 h-card-step-3').addClass('h-card-step-2');
    e.preventDefault();
});
/* Programu korteliu eventai END */